/* eslint-disable import/no-cycle */
import { getShop, isInaEss } from './pageData';
import { logger } from './logger';
import { getCookieValue } from './cookies';
import {
  customDisableProductTriggerUtils,
  extractFreegiftDiscountCodeFromURLUtils,
  extractMerchantDiscountCodeFromURLUtils,
  getCartIconSelectorsUtils,
  getFontSyncModeUtils,
  getFriendsRefUtils,
  getOrderIDUtils,
  getPreviewModeUtils,
  getPTIDUtils,
  getShipProVariantsUtils,
  getWindoKeyUtils,
  getWithExpiryUtils,
  isFontSyncModeUtils,
  removeShipProAutoAddUtils,
  removeShipProOfferIDUtils,
  removeShipProVariantsUtils,
  setExternalDiscountCodeForFunctionsUtils,
  setMerchantDiscountCodeUtils,
  setMrFreegiftDiscountCodeUtils,
  setOpenDrawerUtils,
  setOrderIDUtils,
  setWindowKeyUtils,
  setWithExpiryUtils,
} from '../index-utils';

export var floatingInDisplay = false;

export function getAutoAddFreeGiftsConfig() {
  const key = 'mr_fg_offers';
  try {
    const stringified = localStorage.getItem(key);
    const obj = JSON.parse(stringified);
    if (obj) {
      const { ttl } = obj;
      // old cases where ttl is not set
      if (!ttl) return obj;

      // if set and expired delete
      if (new Date().getTime() > ttl) {
        localStorage.removeItem(key);
      } else {
        return obj;
      }
    }
    return {};
  } catch (e) {
    return {};
  }
}

export function getManualFreeGiftsConfig() {
  const key = 'mr_mfg_offers';
  try {
    const stringified = localStorage.getItem(key);
    const obj = JSON.parse(stringified);
    if (obj) {
      const { ttl } = obj;
      // old cases where ttl is not set
      if (!ttl) return obj;

      // if set and expired delete
      if (new Date().getTime() > ttl) {
        localStorage.removeItem(key);
      } else {
        return obj;
      }
    }
    return {};
  } catch (e) {
    return {};
  }
}

export function getWidgetOfferMapping() {
  const key = 'mr_widget_offerid';
  try {
    const stringified = localStorage.getItem(key);
    const obj = JSON.parse(stringified);
    if (obj) {
      const { ttl } = obj;
      // old cases where ttl is not set
      if (!ttl) return obj;

      // if set and expired delete
      if (new Date().getTime() > ttl) {
        localStorage.removeItem(key);
      } else {
        return obj;
      }
    }
    return {};
  } catch (e) {
    return {};
  }
}

export function setWidgetOfferMapping(data) {
  localStorage.setItem('mr_widget_offerid', data);
}

export function getOrderID() {
  return getOrderIDUtils();
}

export function getOfferID() {
  const floating = getFloating();
  if (floating === 'true') {
    return sessionStorage.getItem('mr_offer_id');
  }
  return '';
}

export function getEmbeddedOfferID(isProductPage) {
  if (isProductPage) {
    return sessionStorage.getItem('mr_em_pr_offer_id');
  }
  return sessionStorage.getItem('mr_em_offer_id');
}

export function getShippingProtectionOfferID() {
  sessionStorage.getItem('mr_em_ship_pro_offer_id');
}

export function getCVBOfferID() {
  return sessionStorage.getItem('mr_em_cvb_offer_id');
}

export function getSubscriptionUpsellOfferID() {
  return sessionStorage.getItem('mr_em_subscription_upsell_offer_id');
}

export function setFloating(value) {
  return sessionStorage.setItem('mr_floating', value);
}

export function getFloating() {
  return sessionStorage.getItem('mr_floating');
}

export function isDisabled() {
  // if the feature is completely blocked and should never
  // be enabled return disabled as true
  const blocked = getBlocked();
  if (blocked === 'true') {
    return 'true';
  }
  return sessionStorage.getItem('mrDisabled');
}

export function setIsDisabled(val) {
  return sessionStorage.setItem('mrDisabled', val);
}

// setBlock ... blocking the app
export function setBlock() {
  // set floating as false
  setFloating('false');
  return sessionStorage.setItem('mrBlocked', 'true');
}

export function getBlocked() {
  return sessionStorage.getItem('mrBlocked');
}

// setOffersDisable ... no more offers to be displayed to the user
export function setOffersDisable(triggerType) {
  // set floating as false
  // setFloating('false');
  sessionStorage.setItem(`mrOfferDisabled${triggerType}`, 'true');
}

export function getOffersDisable(triggerType) {
  return sessionStorage.getItem(`mrOfferDisabled${triggerType}`);
}

export function setOrderProperties(props) {
  const stringified = JSON.stringify(props);
  sessionStorage.setItem('mrOrderProps', stringified);
}

export function getOrderProperties() {
  try {
    const stringified = sessionStorage.getItem('mrOrderProps');
    const obj = JSON.parse(stringified);
    if (obj) {
      return obj;
    }
    return {};
  } catch (e) {
    logger.log('error in getOrderProperties', e);
    return {};
  }
}

export function getDiscountCodeFromApps(discountCodeAction) {
  const discountCode = {};
  try {
    let code = localStorage.getItem('discount_code');

    if (!code) {
      const codeDataString = sessionStorage.getItem(
        'af_entire_checkout_response',
      );

      if (codeDataString) {
        const codeData = JSON.parse(codeDataString);
        const {
          data: { discount_code },
        } = codeData;
        code = discount_code;
      }
    }

    if (!code) {
      code = sessionStorage.getItem('mr_auto_discount_code');
    }

    if (!code) {
      code = getMrDiscountCode() || getMrFreegiftDiscountCode();
    }

    if (!code && isInaEss()) {
      code = getCookieValue('discount_code');
    }

    if (code && code !== '') {
      discountCode.code = code;
      discountCode.action = discountCodeAction || 'checkout';
    }

    // skip the popup
    if (getShop() === 'slyk-shades.myshopify.com') {
      discountCode.action = 'checkout';
    }
  } catch (e) {
    logger.error(e);
  }

  return discountCode;
}

export function setExternalDiscountCodeForFunctions() {
  setExternalDiscountCodeForFunctionsUtils();
}

export function getExternalDiscountCodeForFunctions() {
  return sessionStorage.getItem('mrSFExtDC');
}

export function setMrActiveOffer(offer) {
  const { type, primary } = offer;
  let { offered: offeredProducts } = offer;
  const data = {};
  data.triggerVariantID = primary.sp_variant_id;

  if (type === 'bundle') {
    offeredProducts = offeredProducts.filter(
      product => product.id !== primary.sp_product_id,
    );
  }

  data.offeredVariantIDs = offeredProducts.reduce((prev, curr) => {
    curr.variants.forEach(variant => prev.push(variant.id));

    return prev;
  }, []);
  sessionStorage.setItem('mr_active_offer', JSON.stringify(data));
}

export function setOrderID(orderid) {
  setOrderIDUtils(orderid);
}
export function setOfferID(offerid) {
  sessionStorage.setItem('mr_offer_id', offerid);
}

export function setEmbeddedOfferID(offerid, isProductPage, offerType) {
  if (isProductPage) {
    sessionStorage.setItem('mr_em_pr_offer_id', offerid);
    return;
  }

  if (offerType === 'freegift') {
    sessionStorage.setItem('mr_em_fgm_offer_id', offerid);
    return;
  }

  sessionStorage.setItem('mr_em_offer_id', offerid);
}

export function setCVBOfferID(offerid) {
  sessionStorage.setItem('mr_em_cvb_offer_id', offerid);
}

export const setCVBManualFgOfferConfig = config => {
  sessionStorage.setItem(
    'mr_em_cvb_manual_fg_offer_config',
    JSON.stringify(config),
  );
};

export const getCVBManualFgOfferConfig = () => {
  try {
    const obj = JSON.parse(
      sessionStorage.getItem('mr_em_cvb_manual_fg_offer_config'),
    );
    if (!obj) throw Error();
    return obj;
  } catch (e) {
    return {};
  }
};

export function setSubscriptionUpsellOfferID(offerid) {
  sessionStorage.setItem('mr_em_subscription_upsell_offer_id', offerid);
}

export function setDisabledProductID(id) {
  const disabled = getDisabledProductIDs();
  if (!disabled.some(curr => curr === id)) {
    disabled.push(id);
    sessionStorage.setItem('mr_disabled_id', JSON.stringify(disabled));
  }
}

export function getDisabledProductIDs() {
  try {
    const disabled = JSON.parse(sessionStorage.getItem('mr_disabled_id'));
    if (disabled) {
      return disabled;
    }
  } catch (e) {
    logger.log('error in getDisabledProductIDs', e);
  }
  return [];
}

export function setManualFreeGiftsConfig(offerConfig) {
  localStorage.setItem('mr_mfg_offers', offerConfig);
}

export function setAutoFreeGiftsConfig(offerConfig) {
  localStorage.setItem('mr_fg_offers', offerConfig);
}

export function setCVBFreeGiftConfig(offerConfig) {
  localStorage.setItem('mr_cvbfg_offer_config', offerConfig);
}

export const setNumberOfTimesVariantWasAutoAdded = quantities => {
  sessionStorage.setItem(
    'mr_fg_auto_added_quantities',
    JSON.stringify(quantities),
  );
};

export const getNumberOfTimesVariantWasAutoAdded = () => {
  try {
    const obj = JSON.parse(
      sessionStorage.getItem('mr_fg_auto_added_quantities'),
    );
    if (!obj) throw Error();
    return obj;
  } catch (e) {
    return {};
  }
};

export const getCVBAutoAddedVariantsLimits = () => {
  try {
    const obj = JSON.parse(
      sessionStorage.getItem('mr_cvb_fg_auto_added_quantities'),
    );
    if (!obj) throw Error();
    return obj;
  } catch (e) {
    return {};
  }
};

export const setCVBAutoAddedVariantsLimits = quantities => {
  sessionStorage.setItem(
    'mr_cvb_fg_auto_added_quantities',
    JSON.stringify(quantities),
  );
};

export function getCVBFreeGiftConfig() {
  const key = 'mr_cvbfg_offer_config';
  try {
    const stringified = localStorage.getItem(key);
    const obj = JSON.parse(stringified);
    if (obj) {
      const { ttl } = obj;
      // old cases where ttl is not set
      if (!ttl) return obj;

      // if set and expired delete
      if (new Date().getTime() > ttl) {
        localStorage.removeItem(key);
      } else {
        return obj;
      }
    }
    return { isEnabled: false };
  } catch (e) {
    return { isEnabled: false };
  }
}

export const customDisableProductTrigger = () => {
  customDisableProductTriggerUtils();
};

// function to set the preview mode
export function setPreviewMode(mode) {
  sessionStorage.setItem('mrIsPreviewMode', mode);
}

// function to set the preview mode
export function setFontSyncMode(mode) {
  sessionStorage.setItem('mrIsFontSyncMode', mode);
}

// function to get the preview mode
export function getPreviewMode() {
  return getPreviewModeUtils();
}

// function to get the font-sync mode
export function getFontSyncMode() {
  return getFontSyncModeUtils();
}

// function to set the variant id
export function setPreviewModeVariantID(id) {
  sessionStorage.setItem('mrPreviewVariantID', id);
}

// function to get the preview mode
export function getPreviewModeVariantID() {
  return parseInt(sessionStorage.getItem('mrPreviewVariantID'), 10);
}

// function to set the preview steps status
export function setPreviewStepsDone() {
  sessionStorage.setItem('mrIsPreviewStepsDone', 'true');
}

// function to get the preview steps status
export function getPreviewStepsDone() {
  return sessionStorage.getItem('mrIsPreviewStepsDone');
}

// function to set the setPreviewTrigger
export function setPreviewTriggerType(triggerType) {
  sessionStorage.setItem('mrPreviewTriggerType', triggerType);
}

// function to get the preview trigger
export function getPreviewTriggerType() {
  return sessionStorage.getItem('mrPreviewTriggerType');
}

// function to set the setPreviewFreeGiftAvailing
export function setPreviewFreeGiftAvailingType(freeGiftAvailingType) {
  sessionStorage.setItem('mrPreviewFreeGiftAvailingType', freeGiftAvailingType);
}

// function to get the preview freeGiftAvailingType
export function getPreviewFreeGiftAvailingType() {
  return sessionStorage.getItem('mrPreviewFreeGiftAvailingType');
}

// function to set the PreviewOfferType
export function setPreviewOfferType(offerType) {
  sessionStorage.setItem('mrPreviewOfferType', offerType);
}

// function to get the preview offert type
export function getPreviewOfferType() {
  return sessionStorage.getItem('mrPreviewOfferType');
}

export function getMrDiscountCode() {
  return sessionStorage.getItem('mrDiscountCode');
}

export function getGraphqlCachedData() {
  const graphqlCachedData = sessionStorage.getItem('mrCache');
  if (graphqlCachedData) {
    return JSON.parse(graphqlCachedData);
  }
  return {};
}

export function getMonkAppliedCodes() {
  const monkAppliedCodes = sessionStorage.getItem('mrAppliedDiscountCodes');
  if (monkAppliedCodes) {
    return JSON.parse(monkAppliedCodes);
  }
  return [];
}

export function getShopifyMonkCodesMapping() {
  const monkAppliedCodes = sessionStorage.getItem('mrDiscountCodesMap');
  if (monkAppliedCodes) {
    return JSON.parse(monkAppliedCodes);
  }
  return {};
}

export function setMrDiscountCode(code) {
  return sessionStorage.setItem('mrDiscountCode', code);
}

export function setMRFreeShippingCode(code) {
  return sessionStorage.setItem('mrFSCode', code);
}

export function removeMrDiscountCode() {
  sessionStorage.removeItem('mrAutoDiscountCode');
  return sessionStorage.removeItem('mrDiscountCode');
}

export function getFreeShippingCodefromStorage() {
  const mrFSCode = sessionStorage.getItem('mrFSCode');
  if (mrFSCode) {
    return mrFSCode;
  }
  return '';
}

export function setMRAppliedDiscountCodes(codes) {
  sessionStorage.setItem('mrAppliedDiscountCodes', JSON.stringify(codes));
}

export function getFLoatingInDisplay() {
  return floatingInDisplay;
}

export function setFloatingInDisplay(val) {
  floatingInDisplay = val;
}

export function setOpenPreviewDrawer(val) {
  sessionStorage.setItem('mr_open_preview_drawer', val);
}

export function getOpenPreviewDrawer() {
  return sessionStorage.getItem('mr_open_preview_drawer');
}

export function setRedirectToCheckout(val) {
  sessionStorage.setItem('mr_redirect_checkout', val);
}

export function getRedirectToCheckout() {
  return sessionStorage.getItem('mr_redirect_checkout');
}

export function setOpenDrawer(val) {
  setOpenDrawerUtils(val);
}

export function getOpenDrawer() {
  return sessionStorage.getItem('mr_open_drawer');
}

export function getViewedOffers() {
  const key = 'mr_offer_views';
  try {
    const stringified = sessionStorage.getItem(key);
    const obj = JSON.parse(stringified);
    if (obj) {
      return obj;
    }
  } catch (e) {
    logger.log(e);
  }
  return {};
}

export function setViewedOffers({ mr_offer_id }) {
  const key = 'mr_offer_views';
  const curr = getViewedOffers();
  curr[mr_offer_id] = true;
  sessionStorage.setItem(key, JSON.stringify(curr));
}

export function clearStorage() {
  localStorage.clear();
}

// auto apply normal discount codes flag
export function setMerchantDiscountCode(value) {
  setMerchantDiscountCodeUtils(value);
}

export function setMrFreegiftDiscountCode(value) {
  setMrFreegiftDiscountCodeUtils(value);
}

export function removeMrFreegiftDiscountCode() {
  sessionStorage.removeItem('mrFreegiftDiscountCode');
}

export function getMrFreegiftDiscountCode() {
  return sessionStorage.getItem('mrFreegiftDiscountCode');
}

export function isFGRuleCodeAlreadyApplied() {
  const freegiftRuleCodesMap = getShopifyMonkCodesMapping();
  const monkAppliedCodes = getMonkAppliedCodes();
  const monkFGRuleCodes = [];
  Object.keys(freegiftRuleCodesMap).forEach(fgCode => {
    freegiftRuleCodesMap[fgCode].codes.forEach(monkCode => {
      monkFGRuleCodes.push(monkCode);
    });
  });
  for (let i = 0; i < monkAppliedCodes.length; i += 1) {
    if (monkFGRuleCodes.includes(monkAppliedCodes[i])) {
      return true;
    }
  }
  return false;
}

export function extractFreegiftDiscountCodeFromURL() {
  extractFreegiftDiscountCodeFromURLUtils();
}

export function extractMerchantDiscountCodeFromURL() {
  extractMerchantDiscountCodeFromURLUtils();
}

export function setWithExpiry(key, value, ttl) {
  setWithExpiryUtils(key, value, ttl);
}

export function getWithExpiry(key) {
  return getWithExpiryUtils(key);
}

export function setFGDiscountCodeChecked({ offerID }) {
  sessionStorage.setItem(`mrFgDiscountCodeSet/${offerID}`, 1);
}

export function getFGDiscountCodeChecked({ offerID }) {
  const val = sessionStorage.getItem(`mrFgDiscountCodeSet/${offerID}`);
  return val === '1';
}

export function setDPSDiscountCodeChecked({ offerID }) {
  sessionStorage.setItem(`mrDPSDiscountCodeSet/${offerID}`, 1);
}

export function getDPSDiscountCodeChecked({ offerID }) {
  const val = sessionStorage.getItem(`mrDPSDiscountCodeSet/${offerID}`);
  return val === '1';
}

export function setWindowKey(key, value) {
  setWindowKeyUtils(key, value);
}

export function getWindoKey(key) {
  return getWindoKeyUtils(key);
}

export function getIsDPSEnabled() {
  const configs = getWindoKey('mrUpsellConfig');
  const { isDPSEnabled } = configs;
  return isDPSEnabled;
}

export function getIsDiscountCodeRuleEnabled() {
  const configs = getWindoKey('mrUpsellConfig');
  const { isDiscountCodeRuleEnabled } = configs;
  return isDiscountCodeRuleEnabled;
}

export function getIsShopifyFunctionsEnabled() {
  const configs = getWindoKey('mrUpsellConfig');
  const { isShopifyFunctionsEnabled } = configs;
  return isShopifyFunctionsEnabled;
}

export function getStorefrontAccessToken() {
  const configs = getWindoKey('mrUpsellConfig');
  const { t } = configs;
  return t;
}

export function getCartPageDiscountConfig() {
  const configs = getWindoKey('mrUpsellConfig');
  const { cartPageDiscountConfig } = configs;
  return cartPageDiscountConfig;
}

export function getIsDiscountCodeEnabled() {
  const configs = getWindoKey('mrUpsellConfig');
  const { isDiscountCodeEnabled } = configs;
  return isDiscountCodeEnabled;
}

export function getIsAutomaticDiscountEnabled() {
  const configs = getWindoKey('mrUpsellConfig');
  const { isAutomaticDiscountEnabled } = configs;
  return isAutomaticDiscountEnabled;
}

export function isFontSyncMode() {
  return isFontSyncModeUtils();
}

export function getShipProVariants() {
  return getShipProVariantsUtils();
}

// ship pro
export function setShipProVariants(variants) {
  return localStorage.setItem('mr_em_ship_pro_variants', variants);
}

export function removeShipProVariants() {
  removeShipProVariantsUtils();
}

export function setShipProOfferID(offerid) {
  localStorage.setItem('mr_em_ship_pro_offer_id', offerid);
}

export function getShipProOfferID() {
  return localStorage.getItem('mr_em_ship_pro_offer_id');
}

export function removeShipProOfferID() {
  removeShipProOfferIDUtils();
}

export function getShipProAutoAdd() {
  return sessionStorage.getItem('mr_em_ship_pro_autoAdd') === 'true';
}

export function setShipProAutoAdd(val) {
  sessionStorage.setItem('mr_em_ship_pro_autoAdd', val);
}

export function removeShipProAutoAdd() {
  removeShipProAutoAddUtils();
}

// ship pro end

export function getCartIconSelectors() {
  return getCartIconSelectorsUtils();
}

// pdp fg

export function getPdpFgWidgetList() {
  const widget = sessionStorage.getItem('mr_em_pdp_fg_widget');
  if (widget) {
    return JSON.parse(widget);
  }
  return null;
}

// Below function is used to store widget data in sessionStorage in case of pdp fg.
export function setPdpFgWidgetList(widget) {
  const existingPdpWidgetList = getPdpFgWidgetList();
  const widgetListToStore = [...(existingPdpWidgetList || [])];

  // we have to push the new widget into the list if there is no existing widget list or if the current widget isn't present in the list.
  if (
    !existingPdpWidgetList ||
    (existingPdpWidgetList &&
      !existingPdpWidgetList.some(elem => elem.id === widget.id))
  ) {
    widgetListToStore.push(widget);
  }

  if (widgetListToStore.length > 0) {
    sessionStorage.setItem(
      'mr_em_pdp_fg_widget',
      JSON.stringify(widgetListToStore),
    );
  }
}

export function getPdpFgVariantsWithQuantity() {
  const variantsWithQuantityList = sessionStorage.getItem(
    'mr_em_pdp_fg_variantsWithQuantity',
  );
  if (variantsWithQuantityList) {
    return JSON.parse(variantsWithQuantityList);
  }
  return null;
}

// Below function is used to store variantsWithQuantity data in sessionStorage in case of pdp fg.
export function setPdpFgVariantsWithQuantity({
  widgetID,
  variantsWithQuantity,
  offerID,
}) {
  // below vairable is the existing list containing variantsWithQty for pdp fg offers.
  const existingVariantsWithQuantityList = getPdpFgVariantsWithQuantity();

  // below is the variantsWithQty object that we are looking store in sessionStorage.
  // this is related to the latest pdp fg offer that became eligible
  const newVariantsWithQtyItemToStore = {
    widgetID,
    variantsWithQuantity,
    offerID,
  };
  let dataToStore = [...(existingVariantsWithQuantityList || [])];
  let doesAnElementWithSameOfferIDExists = false;
  let sameOfferIDButDifferentProduct = false;

  if (existingVariantsWithQuantityList) {
    doesAnElementWithSameOfferIDExists = existingVariantsWithQuantityList.some(
      elem => elem.offerID === newVariantsWithQtyItemToStore.offerID,
    );

    sameOfferIDButDifferentProduct = existingVariantsWithQuantityList.some(
      elem =>
        elem.offerID === newVariantsWithQtyItemToStore.offerID &&
        elem.variantsWithQuantity[0].sp_product_id !==
          newVariantsWithQtyItemToStore.variantsWithQuantity[0].sp_product_id,
    );
  }

  // if the new offerID is same as the existing offerID but the product is different, we need to replace the old element with the new one.
  if (existingVariantsWithQuantityList && sameOfferIDButDifferentProduct) {
    const filteredData = existingVariantsWithQuantityList.filter(
      elem => elem.offerID !== newVariantsWithQtyItemToStore.offerID,
    );
    dataToStore = [...filteredData, newVariantsWithQtyItemToStore];
  }

  // if there is no existing list or if the offerID is different, we need to push the new element into the list.
  if (
    !existingVariantsWithQuantityList ||
    (existingVariantsWithQuantityList && !doesAnElementWithSameOfferIDExists)
  ) {
    dataToStore.push(newVariantsWithQtyItemToStore);
  }

  if (dataToStore.length > 0) {
    sessionStorage.setItem(
      'mr_em_pdp_fg_variantsWithQuantity',
      JSON.stringify(dataToStore),
    );
  }
}

export function getAutoAddedVariantsDataWithRepetetionCount() {
  const storedData = JSON.parse(
    sessionStorage.getItem('mr_em_fg_widget_level_auto_added_data'),
  );
  return storedData;
}

export function resetAutoAddedVariantsDataWithRepitionCount({ widgetID }) {
  const existingData = getAutoAddedVariantsDataWithRepetetionCount();
  if (existingData && existingData[widgetID]) {
    delete existingData[widgetID];
    sessionStorage.setItem(
      'mr_em_fg_widget_level_auto_added_data',
      JSON.stringify(existingData),
    );
  }
}

export function setAutoAddedVariantsDataWithRepitionCount({
  widgetID,
  rulesEligibilityCount,
  autoAddedProducts,
  reservedItemQuantity,
}) {
  const objectWithCountAndProducts = {
    rulesEligibilityCount,
    autoAddedProducts,
    reservedItemQuantity,
  };

  let dataToStore = {};

  const existingData = getAutoAddedVariantsDataWithRepetetionCount();
  if (existingData) {
    dataToStore = { ...existingData, [widgetID]: objectWithCountAndProducts };
  } else {
    dataToStore = {
      [widgetID]: objectWithCountAndProducts,
    };
  }

  sessionStorage.setItem(
    'mr_em_fg_widget_level_auto_added_data',
    JSON.stringify(dataToStore),
  );
}

// custom attribute used by a merchant
export function getPTID() {
  return getPTIDUtils();
}

// custom attribute used by a merchant
export function getFriendsRef() {
  return getFriendsRefUtils();
}
